"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MergeModal = exports.EditModal = exports.DeleteModal = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _Modal = require("@insided/shared/uikit/Modal");

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var EditModal = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EditModal, _Component);

  var _super = _createSuper(EditModal);

  function EditModal() {
    var _this$props$tag;

    var _this;

    (0, _classCallCheck2.default)(this, EditModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      newName: (_this$props$tag = _this.props.tag) !== null && _this$props$tag !== void 0 ? _this$props$tag : ''
    });
    return _this;
  }

  (0, _createClass2.default)(EditModal, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          tag = _this$props.tag,
          onSave = _this$props.onSave,
          onClose = _this$props.onClose,
          onClick = _this$props.onClick,
          error = _this$props.error;
      var newName = this.state.newName;
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: true,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: tag ? "Edit public tag '".concat(tag, "'") : 'New public tag',
        onClose: onClose
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)(_InputGroup.default, {
        title: "Tag name",
        placeholder: "Add tag name",
        qaClasses: "qa-add-tag-input",
        value: newName,
        onChange: function onChange(e) {
          return _this2.setState({
            newName: e.target.value
          });
        },
        onClick: onClick,
        maxlength: 45,
        error: error
      })), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
        className: "qa-public-tag-save",
        title: "Save changes",
        variant: "save",
        newStyle: true,
        onClick: function onClick() {
          return onSave(newName);
        }
      }), (0, _preact.h)(_buttonControl.default, {
        className: "qa-public-tag-cancel",
        newStyle: true,
        title: "Cancel",
        onClick: onClose
      })));
    }
  }]);
  return EditModal;
}(_preact.Component);

exports.EditModal = EditModal;

var DeleteModal = function DeleteModal(_ref) {
  var tag = _ref.tag,
      onDelete = _ref.onDelete,
      onClose = _ref.onClose;
  return (0, _preact.h)(_Modal.Modal, {
    isOpen: true,
    size: "medium"
  }, (0, _preact.h)(_Modal.ModalHeader, {
    title: "Delete public tag '".concat(tag, "'?"),
    onClose: onClose
  }), (0, _preact.h)(_Modal.ModalBody, null, "All topics with this public tag previously will lose it."), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
    title: "Delete",
    className: "qa-public-tag-delete",
    variant: "warning",
    newStyle: true,
    onClick: onDelete
  }), (0, _preact.h)(_buttonControl.default, {
    newStyle: true,
    title: "Cancel",
    className: "qa-public-tag-cancel",
    onClick: onClose
  })));
};

exports.DeleteModal = DeleteModal;

var MergeModal = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(MergeModal, _Component2);

  var _super2 = _createSuper(MergeModal);

  function MergeModal() {
    var _this3$props$tag;

    var _this3;

    (0, _classCallCheck2.default)(this, MergeModal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "state", {
      newName: (_this3$props$tag = _this3.props.tag) !== null && _this3$props$tag !== void 0 ? _this3$props$tag : ''
    });
    return _this3;
  }

  (0, _createClass2.default)(MergeModal, [{
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          onSave = _this$props2.onSave,
          onClose = _this$props2.onClose,
          onClick = _this$props2.onClick,
          error = _this$props2.error,
          mergeCount = _this$props2.mergeCount;
      var newName = this.state.newName;
      return (0, _preact.h)(_Modal.Modal, {
        isOpen: true,
        size: "medium"
      }, (0, _preact.h)(_Modal.ModalHeader, {
        title: "Merge ".concat(mergeCount, " public tags"),
        onClose: onClose
      }), (0, _preact.h)(_Modal.ModalBody, null, (0, _preact.h)(_InputGroup.default, {
        title: "Tag name",
        placeholder: "Add tag name",
        qaClasses: "qa-merge-tag-input",
        value: newName,
        onChange: function onChange(e) {
          return _this4.setState({
            newName: e.target.value
          });
        },
        onClick: onClick,
        maxlength: 45,
        error: error
      })), (0, _preact.h)(_Modal.ModalFooter, null, (0, _preact.h)(_buttonControl.default, {
        className: "qa-public-tag-merge",
        title: "Save changes",
        variant: "save",
        newStyle: true,
        onClick: function onClick() {
          return onSave(newName);
        }
      }), (0, _preact.h)(_buttonControl.default, {
        newStyle: true,
        className: "qa-public-tag-cancel",
        title: "Cancel",
        onClick: onClose
      })));
    }
  }]);
  return MergeModal;
}(_preact.Component);

exports.MergeModal = MergeModal;